var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"25f94a7da74fe4c964dbd884f902733c3304bb44"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend@ecomio"]={id:"25f94a7da74fe4c964dbd884f902733c3304bb44"};
      